import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { useParams } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import * as Constants from '../Constants';
import moment from 'moment';
import '../App.css';
import EventStatus from './EventStatus';

const VideoConferenceEvent = () => {
  const [meetingId, setMeetingId] = useState('');
  const [meetingPassword, setMeetingPassword] = useState('');
  const [scheduledEvent, setScheduledEvent] = useState(null);
  const [eventUsers, setEventUsers] = useState([]);
  const [status, setStatus]= useState(scheduledEvent ? EventStatus.getEventStatus(scheduledEvent) : Constants.EVENT_NOT_READY);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    const fetchEvent = async (id) => {
      const params = {
        _id: id,
      };
      await rpc({
        method: 'GetScheduledEvent',
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: setScheduledEvent
      });
    };
    fetchEvent(id);
  }, [id]);

  useEffect(() => {
    const onFetchSuccess = (usersInGroup) => {
      setEventUsers((prevUsers) => {
        const allUsers = prevUsers.concat(usersInGroup);
        const uniqueIds = new Set();
        const result = allUsers.filter((user) => {
          const isDuplicate = uniqueIds.has(user._id);
          uniqueIds.add(user._id);
          return !isDuplicate;
        });
        return result;
      });
    };
  
    const fetchUsersInGroup = async (group_id) => {
      const params = {
        _eventGroups: group_id,
      };
      rpc({
        method: 'GetUsers',
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: onFetchSuccess
      });
    };
    if (scheduledEvent !== null) {
      setStatus(EventStatus.getEventStatus(scheduledEvent));
      scheduledEvent._eventGroups.forEach(group => {
        fetchUsersInGroup(group);
      });
    }
  }, [scheduledEvent]);

  useEffect(() => {
    const timer = setInterval(() => {
      if (scheduledEvent !== null) {
        setStatus(EventStatus.getEventStatus(scheduledEvent));
      }
    }, 5000); // Refresh every 5 seconds    
    return () => {
      // Clean up the timer when the component unmounts
      clearInterval(timer);
    };
  }, [scheduledEvent]);

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const startVideoConference = async () => {
    if (meetingId === '' || meetingPassword === '') {
      setErrorMessage('Please enter a meeting id and password.');
      setOpenErrorDialog(true);
      return;
    }
    EventStatus.setEventStatus(scheduledEvent, Constants.EVENT_STARTED);
    setStatus(Constants.EVENT_STARTED);
    // make it so, update the database
    const params = {
      _id: scheduledEvent._id,
      status: Constants.EVENT_STARTED,
      zoomId: meetingId.replace(/\D/g, ''),
      zoomPassword: meetingPassword
    };
    rpc({
      method: 'UpdateScheduledEvent',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess: () => {console.log("UpdateScheduleEvent success");}
    });
  };

  const getTitle = () => {
    if (scheduledEvent === null) {
      return '';
    }
    const shownOn = moment(scheduledEvent.shownOn).format(Constants.TIME_FORMAT);
    const statusText= Constants.EVENT_STATUS_TEXT[status];
    return`${scheduledEvent._event.name} ${shownOn} ${statusText}`;
  };

  const getUsers = () => {
    return eventUsers.map((user) => {
      return `${user.first} ${user.last}`;
    }).join(', ');
  };

  const canStart = () => {
    return status === Constants.EVENT_STOPPED;
  };

  return (
    <div className="VideoConferenceEventDetails">
      <Typography variant="h6" gutterBottom>
        Event {getTitle()}
      </Typography>
      <Typography variant="h8">
        Users {getUsers()}
      </Typography>
      <TextField className="TextField"
        label="Meeting Id"
        value={meetingId}
        onChange={(e) => setMeetingId(e.target.value)}
      />
      <TextField className="TextField"
        label="Password"
        value={meetingPassword}
        type="password"
        onChange={(e) => setMeetingPassword(e.target.value)}
      />
      <Button className="Button" variant="contained" color="primary" 
        disabled={!canStart()}
        onClick={startVideoConference}>
        Start
      </Button>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default VideoConferenceEvent;
